import {
  TravelExpenseApiRequest,
  UpdateTravelExpensesCurrencyInput
} from '../../components/pages/staff/staff-personal-space/travel-expenses.utils'
import { Files } from '../../lib/constants/files'
import { TravelExpense } from '../../lib/types/models/travel-expenses/travel-expenses'
import { IdInput } from '../../lib/types/utils'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function createOrUpdateMissionToStaffTravelExpenses(
  missionToStaffId: number,
  input: TravelExpenseApiRequest[]
) {
  for (const expense of input)
    if (expense.document) {
      const uploadedDocument = await uploadFile(Files.TRAVEL_EXPENSES_INVOICE, expense.document)
      if (!uploadedDocument) throw new Error('File not uploaded')
      expense.document = uploadedDocument
    }

  return restApiClient
    .url(
      constructApiUrl(API.missionToStaffs.createOrUpdateTravelExpenses.url, {
        id: missionToStaffId
      })
    )
    .post<TravelExpense[], TravelExpenseApiRequest[]>(input)
}

export const updateMissionToStaffTravelExpensesCurrency = async (
  input: IdInput<UpdateTravelExpensesCurrencyInput>
) => {
  const { id, ...rest } = input
  return restApiClient
    .url(constructApiUrl(API.missionToStaffs.updateTravelExpensesCurrency.url, { id }))
    .patch(rest)
}
